/* ECINOS - Auto-add stiker gratis (promo Buy 1 Get 1 Sticker)
   Aktif sampai 24 Agustus 2026 23:59 WIB, setelah itu script berhenti sendiri.
   Diskon Rp0-nya diatur oleh discount otomatis "Beli 1 Gratis Stiker Limited" di admin. */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 48624314941634;
  var PROMO_END = Date.parse('2026-08-24T16:59:00Z');
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var running = false;

  function promoActive() {
    return Date.now() < PROMO_END;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function asJson(res) {
    if (!res.ok) throw new Error('cart request failed: ' + res.status);
    return res.json();
  }

  function getCart() {
    return fetch(root() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(asJson);
  }

  function post(path, payload) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(asJson);
  }

  function afterChange() {
    document.dispatchEvent(new CustomEvent('ecinos:gift-updated'));
    if (/\/cart(\/|$)/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  function sync() {
    if (running || !promoActive()) return Promise.resolve();
    running = true;

    return getCart()
      .then(function (cart) {
        var gift = null;
        var others = 0;

        (cart.items || []).forEach(function (item) {
          if (item.variant_id === GIFT_VARIANT_ID) {
            gift = item;
          } else {
            others += item.quantity;
          }
        });

        if (others > 0 && !gift) {
          return post('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }).then(afterChange);
        }
        if (others > 0 && gift && gift.quantity !== 1) {
          return post('cart/change.js', { id: String(GIFT_VARIANT_ID), quantity: 1 }).then(afterChange);
        }
        if (others === 0 && gift) {
          return post('cart/change.js', { id: String(GIFT_VARIANT_ID), quantity: 0 }).then(afterChange);
        }
        return null;
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('[ecinos free gift]', err);
      })
      .then(function () {
        running = false;
      });
  }

  function schedule(url) {
    if (running || typeof url !== 'string') return;
    if (CART_MUTATION.test(url.split('?')[0])) setTimeout(sync, 350);
  }

  function patchFetch() {
    if (!window.fetch || window.__ecinosGiftFetch) return;
    window.__ecinosGiftFetch = true;
    var original = window.fetch;
    window.fetch = function () {
      var first = arguments[0];
      var url = typeof first === 'string' ? first : (first && first.url) || '';
      return original.apply(this, arguments).then(function (res) {
        schedule(url);
        return res;
      });
    };
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.__ecinosGiftXhr) return;
    window.__ecinosGiftXhr = true;
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        schedule(url);
      });
      return open.apply(this, arguments);
    };
  }

  function init() {
    if (!promoActive()) return;
    patchFetch();
    patchXhr();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
